export default __webpack_public_path__ + "static/media/Group 6424@3x.736e83cc.png";